import React, { useState } from 'react';
import { changePassword } from '../api/api';
import useAuth from '../hooks/useAuth';
import styles from './SettingsPage.module.css'; // On va créer ce CSS juste après

const SettingsPage = () => {
    const { user } = useAuth();
    
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: '', message: '' });

        if (formData.newPassword !== formData.confirmPassword) {
            setStatus({ type: 'error', message: 'Les nouveaux mots de passe ne correspondent pas.' });
            return;
        }

        if (formData.newPassword.length < 6) {
            setStatus({ type: 'error', message: 'Le mot de passe doit contenir au moins 6 caractères.' });
            return;
        }

        setLoading(true);
        try {
            await changePassword({
                oldPassword: formData.oldPassword,
                newPassword: formData.newPassword
            });
            setStatus({ type: 'success', message: 'Mot de passe modifié avec succès !' });
            setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
        } catch (err) {
            const errorMsg = err.response?.data?.error || "Erreur lors du changement de mot de passe.";
            setStatus({ type: 'error', message: errorMsg });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <h1 className={styles.title}>Paramètres du compte</h1>
                    <p className={styles.subtitle}>Gérez vos préférences et votre sécurité.</p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>👤 Informations</h2>
                    <div className={styles.infoRow}>
                        <label>Nom complet :</label>
                        <span>{user?.prenom} (ID: {user?.id})</span>
                    </div>
                    <div className={styles.infoRow}>
                        <label>Email :</label>
                        <span>{user?.email}</span>
                    </div>
                    <div className={styles.infoRow}>
                        <label>Rôle :</label>
                        <span className={styles.roleTag}>{user?.type}</span>
                    </div>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>🔒 Sécurité</h2>
                    <form onSubmit={handleSubmit} className={styles.form}>
                        {status.message && (
                            <div className={`${styles.alert} ${status.type === 'error' ? styles.alertError : styles.alertSuccess}`}>
                                {status.message}
                            </div>
                        )}

                        <div className={styles.formGroup}>
                            <label htmlFor="oldPassword">Ancien mot de passe</label>
                            <input
                                type="password"
                                id="oldPassword"
                                name="oldPassword"
                                value={formData.oldPassword}
                                onChange={handleChange}
                                required
                                placeholder="Votre mot de passe actuel"
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="newPassword">Nouveau mot de passe</label>
                            <input
                                type="password"
                                id="newPassword"
                                name="newPassword"
                                value={formData.newPassword}
                                onChange={handleChange}
                                required
                                placeholder="Nouveau mot de passe (min. 6 char)"
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="confirmPassword">Confirmer le nouveau mot de passe</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                                placeholder="Répétez le mot de passe"
                            />
                        </div>

                        <button type="submit" className={styles.saveBtn} disabled={loading}>
                            {loading ? 'Modification...' : 'Changer le mot de passe'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;